module.exports = __webpack_public_path__ + "img/semfoto.9abb7ff9.png";